/* ═══════════════════════════════════════════════════════════════════════
   MODERN BOARD GAME CATALOG - ENHANCED FUNCTIONALITY
   ═══════════════════════════════════════════════════════════════════════ */

let pending = null;
let allGames = [];
let wishlist = new Set();

// Load wishlist from localStorage
try {
  const saved = localStorage.getItem("wishlist");
  if (saved) {
    wishlist = new Set(JSON.parse(saved));
  }
} catch (e) {
  console.error("Error loading wishlist:", e);
}

// Initialize Google Charts and fetch data
google.charts.load("current", { packages: ["corechart"] });
google.charts.setOnLoadCallback(fetchSheet);

/* ═══════════════════════════════════════════════════════════════════════
   DATA FETCHING & LOADING STATE
   ═══════════════════════════════════════════════════════════════════════ */

function showLoading() {
  const grid = el("grid");
  grid.innerHTML = `
    <div class="loading-container">
      <div class="spinner"></div>
      <p style="color: var(--text-secondary); font-size: 1.1rem;">Loading amazing board games...</p>
    </div>
  `;
}

function fetchSheet() {
  showLoading();
  const SHEET_ID = "1kI0WKTzXjpaS1B2Gh1ffNf7EWXANHf61mNk-MXnCtyQ";
  const URL = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?gid=0&tqx=out:json`;
  new google.visualization.Query(URL).send(handleSheets);
}

function handleSheets(resp) {
  if (resp.isError()) {
    console.error(resp.getMessage());
    showError("Failed to load games. Please refresh the page.");
    return;
  }

  const dt = resp.getDataTable(),
    cols = dt.getNumberOfColumns(),
    rows = dt.getNumberOfRows(),
    hdrs = Array.from({ length: cols }, (_, c) => dt.getColumnLabel(c));

  allGames = [];
  for (let r = 0; r < rows; r++) {
    const o = {};
    hdrs.forEach((h, i) => (o[h] = dt.getValue(r, i) || ""));
    allGames.push(o);
  }

  initPage(allGames);
}

function showError(message) {
  const grid = el("grid");
  grid.innerHTML = `
    <div class="empty-state">
      <div class="empty-state-icon">⚠️</div>
      <h3>Oops! Something went wrong</h3>
      <p>${message}</p>
    </div>
  `;
}

/* ═══════════════════════════════════════════════════════════════════════
   CONDITION CLASSIFICATION
   ═══════════════════════════════════════════════════════════════════════ */

function getConditionClass(cond) {
  if (!cond) return "cond-default";

  const c = cond.toLowerCase().trim();

  // 1. TEAL: Like New / Near Mint / Unpunched
  if (
    c.includes("like new") ||
    c.includes("near mint") ||
    c.includes("nm") ||
    c.includes("unpunched") ||
    c.includes("ln") ||
    c.includes("excellent") ||
    c.includes("open box")
  ) {
    return "cond-likenew";
  }

  // 2. GREEN: New / Sealed / Mint
  if (
    c.includes("new") ||
    c.includes("sealed") ||
    c.includes("shrink") ||
    c.includes("nis") ||
    c.includes("mint") ||
    c === "n"
  ) {
    return "cond-new";
  }

  // 3. YELLOW: Very Good
  if (
    c.includes("very good") ||
    c.includes("vg") ||
    c.includes("punched") ||
    c.includes("great")
  ) {
    return "cond-vg";
  }

  // 4. ORANGE: Good / Played
  if (
    c.includes("good") ||
    c.includes("played") ||
    c === "g" ||
    c.includes("used")
  ) {
    return "cond-good";
  }

  // 5. RED: Acceptable / Poor / Fair
  if (
    c.includes("acceptable") ||
    c.includes("fair") ||
    c.includes("poor") ||
    c.includes("worn") ||
    c.includes("damage") ||
    c.includes("box wear")
  ) {
    return "cond-poor";
  }

  return "cond-default";
}

/* ═══════════════════════════════════════════════════════════════════════
   TOAST NOTIFICATIONS
   ═══════════════════════════════════════════════════════════════════════ */

function showToast(message, type = "info") {
  const container = el("toast-container");
  if (!container) {
    const newContainer = document.createElement("div");
    newContainer.id = "toast-container";
    document.body.appendChild(newContainer);
  }

  const icons = {
    success: "✓",
    error: "✗",
    info: "ℹ",
    warning: "⚠",
  };

  const toast = document.createElement("div");
  toast.className = `toast ${type}`;
  toast.innerHTML = `
    <div class="toast-icon">${icons[type] || icons.info}</div>
    <div class="toast-message">${message}</div>
  `;

  const toastContainer = el("toast-container");
  toastContainer.appendChild(toast);

  setTimeout(() => {
    toast.style.animation = "slideInRight 0.3s ease reverse";
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

/* ═══════════════════════════════════════════════════════════════════════
   PAGE INITIALIZATION
   ═══════════════════════════════════════════════════════════════════════ */

function initPage(games) {
  const placeholder =
      "https://dummyimage.com/600x400/1a1f2e/5d9cec&text=No+Cover",
    fs = el("filter-company"),
    ts = el("filter-type"),
    ps = el("filter-periods"),
    pl = el("filter-players"),
    cs = el("filter-condition"),
    grid = el("grid");

  const typeColors = {
    "Coin Games": "#e6194b",
    "Great Battles of History": "#3cb44b",
    "Simonitch 19XX Series": "#4363d8",
    "Combat Commander Series": "#f58231",
    "Operational Combat Series": "#911eb4",
    "Battalion Combat Series": "#37bbbb",
    "Series: Vive l'Empereur !": "#f032e6",
    "Lock and Load: Tactical": "#bcf60c",
    "World at War 85 Series": "#fabebe",
    "Band of Brothers": "#008080",
    "Series: Blind Swords System": "#d397f9",
    "Series: The Library of Napoleonic Battles": "#9a6324",
    "Series: Leader": "#865a00",
    "Series: Warfighter": "#800000",
    "Series: Valiant Defense": "#6cae7f",
    "Series: States of Siege": "#808080",
    "Series: BIOS": "#000000",
    "Series: Pax": "#f5b06b",
    "Solo Design": "#000075",
    "Series: Great Sieges": "#808000",
    "Series: Nations at War": "#78826e",
    "Standard Combat Series": "#800080",
    "Series: GCACW": "#a9a9a9",
    ASL: "#484800",
    "Levy & Campaign": "#793e51",
    "East Front Series": "#ff7aa6",
  };

  const statusColor = {
    AVAILABLE: "#27ae60",
    "PRE-ORDER": "#9b59b6",
    SOLD: "#e74c3c",
    OOP: "#7f8f8d",
  };

  // Build filter options
  const comps = new Set(),
    types = new Set(),
    periods = new Set(),
    players = new Set(),
    conds = new Set();

  games.forEach((g) => {
    if (g.Company) comps.add(g.Company);
    if (g.Type) {
      g.Type.split(",")
        .map((x) => x.trim())
        .forEach((t) => types.add(t));
    }
    if (g["Historical Periods"]) periods.add(g["Historical Periods"]);
    if (g["Players"]) players.add(g["Players"]);
    if (g["Condition"]) conds.add(g["Condition"]);
  });

  function addOptions(set, select, allLabel) {
    select.innerHTML = "";
    const allOpt = document.createElement("option");
    allOpt.value = "All";
    allOpt.textContent = allLabel;
    select.appendChild(allOpt);
    Array.from(set)
      .sort()
      .forEach((v) => {
        const o = document.createElement("option");
        o.value = v;
        o.textContent = v;
        select.appendChild(o);
      });
  }

  addOptions(comps, fs, "All Companies");
  addOptions(types, ts, "All Series");
  addOptions(periods, ps, "All Periods");
  addOptions(players, pl, "All Player Counts");
  addOptions(conds, cs, "All Conditions");

  // Clear grid
  grid.innerHTML = "";

  // Render game cards
  games.forEach((g) => {
    const rawStatus = (g.Sold || "").toString().trim().toUpperCase(),
      hasRibbon = rawStatus in statusColor,
      ribbonClr = statusColor[rawStatus] || "#3498db",
      extras = (g.Extras || "")
        .split(";")
        .map((p) => {
          const [n, pr] = p.split("|").map((x) => x.trim());
          return pr ? { name: n, price: pr } : null;
        })
        .filter(Boolean),
      card = document.createElement("div");

    const finalPrice = parseFloat(g.Price),
      originalPrice = parseFloat(g["Original Price"]),
      hasFinalPrice = !isNaN(finalPrice) && finalPrice > 0,
      hasOriginalPrice = !isNaN(originalPrice) && originalPrice > 0,
      hasDiscount =
        hasFinalPrice && hasOriginalPrice && originalPrice > finalPrice,
      discountPercent = hasDiscount
        ? Math.round(((originalPrice - finalPrice) / originalPrice) * 100)
        : null;

    const condClass = getConditionClass(g["Condition"]);
    const typeList = g.Type ? g.Type.split(",").map((x) => x.trim()) : [];
    const gameTitle = g.Title || "Unknown Game";
    const isInWishlist = wishlist.has(gameTitle);

    card.className = "card";
    card.dataset.title = (g.Title || "").toLowerCase();
    card.dataset.company = g.Company;
    card.dataset.type = typeList.join("|");
    card.dataset.period = g["Historical Periods"] || "";
    card.dataset.players = g["Players"] || "";
    card.dataset.condition = g["Condition"] || "";
    card.dataset.price = hasFinalPrice ? finalPrice.toFixed(2) : "0.00";
    card.dataset.originalPrice = hasOriginalPrice
      ? originalPrice.toFixed(2)
      : "";
    card.dataset.hasExtras = extras.length ? "1" : "0";
    card.dataset.link = g.BGGLink;
    card.dataset.extras = JSON.stringify(extras);
    card.dataset.imageUrl = g.ImageURL || placeholder;

    card.innerHTML = `
      ${
        hasRibbon
          ? `<div class="ribbon">
             <span style="background-color:${ribbonClr};">${rawStatus}</span>
           </div>`
          : ""
      }

      <div class="card-image" data-title="${gameTitle}" data-image="${g.ImageURL || placeholder}">
        <img src="${g.ImageURL || placeholder}" alt="${gameTitle}" loading="lazy">
        <div class="image-overlay">🔍 Click to enlarge</div>
      </div>

      <div class="card-details">
        <div class="type-labels">
          ${typeList
            .map(
              (t) =>
                `<div class="type-label" style="background-color:${typeColors[t] || "#9c8080"}">
               ${t}
             </div>`
            )
            .join("")}
        </div>

        <h2 class="title">
          <a href="${g.BGGLink}" target="_blank" rel="noopener">${gameTitle}</a>
        </h2>

        <div class="info-grid">
          <div class="info-row">
            <span class="label"><div class="emoji">👥</div><div>Players</div></span>
            <span class="value">${g["Players"] || "N/A"}</span>
          </div>
          <div class="info-row">
            <span class="label"><div class="emoji">⏳</div><div>Period</div></span>
            <span class="value">${g["Historical Periods"] || "N/A"}</span>
          </div>
          <div class="info-row">
            <span class="label"><div class="emoji">📚</div><div>Edition</div></span>
            <span class="value">${g["Edition/Version"] || "N/A"}</span>
          </div>
          <div class="info-row">
            <span class="label"><div class="emoji">🏢</div><div>Company</div></span>
            <span class="value">${g.Company || "N/A"}</span>
          </div>
        </div>

        <div class="condition-display ${condClass}">
          ${g["Condition"] || "Unknown"}
        </div>

        ${
          extras.length
            ? '<div class="extras-row"><span class="label">⭐ Extras</span><span class="value">Available</span></div>'
            : ""
        }

        <div class="pricing">
          <div class="price-stack">
            ${hasOriginalPrice ? `<span class="original-price">€${originalPrice.toFixed(2)}</span>` : ""}
            <span class="final-price">${hasFinalPrice ? `€${finalPrice.toFixed(2)}` : "Price TBA"}</span>
            ${hasDiscount ? `<span class="discount-pill">Save ${discountPercent}%</span>` : ""}
          </div>
          ${
            rawStatus === "AVAILABLE" ||
            rawStatus === "PRE-ORDER" ||
            rawStatus === ""
              ? `<button class="add-btn" data-testid="add-to-cart-${gameTitle.toLowerCase().replace(/\\s+/g, "-")}">Add to Cart</button>`
              : `<button class="sold-btn" disabled data-testid="sold-${gameTitle.toLowerCase().replace(/\\s+/g, "-")}">${rawStatus}</button>`
          }
        </div>

        <div class="extras-panel">
          <h3>Select Extras</h3>
          <ul class="extras-list"></ul>
          <button class="confirm-btn">Confirm Selection</button>
          <button class="cancel-btn">Cancel</button>
        </div>
      </div>
    `;

    grid.appendChild(card);
  });

  setupInteractions();
  updateStats();
}

/* ═══════════════════════════════════════════════════════════════════════
   INTERACTION SETUP
   ═══════════════════════════════════════════════════════════════════════ */

function setupInteractions() {
  const cart = new Map(),
    saved = localStorage.getItem("cartItems") || "[]";
  JSON.parse(saved).forEach((i) => cart.set(i.title, i));

  const cards = Array.from(document.querySelectorAll(".card")),
    ct = el("cart-toggle"),
    dr = el("cart-drawer"),
    cb = el("close-cart"),
    bd = el("cart-count"),
    il = el("cart-items"),
    copyBtn = el("copy-cart"),
    clearBtn = el("clear-cart"),
    st = el("subtotal"),
    si = el("search-input"),
    fs = el("filter-company"),
    ts = el("filter-type"),
    ps = el("filter-periods"),
    pl = el("filter-players"),
    cs = el("filter-condition"),
    sortSel = el("sort-select"),
    filterDrawer = el("filter-drawer"),
    shield = el("page-shield"),
    fcClose = el("filter-close"),
    fcClear = el("filter-clear"),
    filterToggle = el("filter-toggle"),
    wishlistToggle = el("wishlist-toggle"),
    wishlistCount = el("wishlist-count"),
    scrollTop = el("scroll-top");

  // Quick View Modal Setup
  setupQuickView();

  // Header compaction on scroll
  const pageHeader = document.getElementById("page-header");
  if (pageHeader) {
    let lastKnownScrollY = window.scrollY;
    let ticking = false;
    const collapseStart = 40;
    const collapseEnd = 220;
    const collapseRange = collapseEnd - collapseStart;

    const updateHeader = () => {
      ticking = false;
      const progress = Math.min(
        1,
        Math.max(0, (lastKnownScrollY - collapseStart) / collapseRange)
      );
      pageHeader.style.setProperty("--header-collapse", progress.toFixed(3));
      pageHeader.classList.toggle("header-compact", progress > 0.02);
    };

    window.addEventListener("scroll", () => {
      lastKnownScrollY = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    });

    updateHeader();
  }

  // Scroll to top button
  if (scrollTop) {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 500) {
        scrollTop.classList.add("visible");
      } else {
        scrollTop.classList.remove("visible");
      }
    });

    scrollTop.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  function save() {
    localStorage.setItem("cartItems", JSON.stringify([...cart.values()]));
  }

  function saveWishlist() {
    localStorage.setItem("wishlist", JSON.stringify([...wishlist]));
  }

  function updateCart() {
    bd.textContent = cart.size;
    il.innerHTML =
      '<li class="header"><div>Title</div><div>Price</div><div></div></li>';
    let total = 0;

    cart.forEach((i) => {
      const li = document.createElement("li"),
        t = document.createElement("div"),
        p = document.createElement("div"),
        d = document.createElement("div"),
        b = document.createElement("button");

      t.className = "item-details";
      t.innerHTML = `${i.title} ${i.condition ? `<span class="cart-cond">${i.condition}</span>` : ""}`;

      p.textContent = `€${i.price}`;

      b.className = "remove-btn";
      b.innerText = "×";
      b.onclick = () => {
        cart.delete(i.title);
        updateCart();
        showToast("Removed from cart", "info");
      };
      d.appendChild(b);
      li.append(t, p, d);
      il.appendChild(li);
      total += parseFloat(i.price);
    });

    st.textContent = `€${total.toFixed(2)}`;

    cards.forEach((c) => {
      const ttl = c.querySelector("h2 a").textContent,
        btn = c.querySelector(".add-btn");
      if (btn) {
        if (cart.has(ttl)) {
          btn.textContent = "Added ✓";
          btn.disabled = true;
        } else {
          btn.textContent = "Add to Cart";
          btn.disabled = false;
        }
      }
    });

    copyBtn.disabled = cart.size === 0;
    save();
  }

  function updateWishlistUI() {
    if (wishlistCount) {
      wishlistCount.textContent = wishlist.size;
    }
    cards.forEach((c) => {
      const title = c.querySelector("h2 a").textContent;
      // You can add wishlist heart icon here if needed
    });
  }

  function filterAndSort() {
    const term = si.value.trim().toLowerCase(),
      comp = fs.value,
      typ = ts.value,
      per = ps.value,
      play = pl.value,
      cond = cs.value,
      exf = document.querySelector(
        'input[name=\"filter-extras\"]:checked'
      ).value,
      sort = sortSel.value;

    let visibleCount = 0;
    cards.forEach((c) => {
      const okC = comp === "All" || c.dataset.company === comp,
        okT = typ === "All" || c.dataset.type.split("|").includes(typ),
        okP = per === "All" || c.dataset.period === per,
        okL = play === "All" || c.dataset.players === play,
        okCond = cond === "All" || c.dataset.condition === cond,
        hasE = c.dataset.hasExtras === "1",
        okE =
          exf === "any" ||
          (exf === "with" && hasE) ||
          (exf === "without" && !hasE),
        okS = !term || c.dataset.title.includes(term);

      if (okC && okT && okP && okL && okCond && okE && okS) {
        c.style.display = "";
        visibleCount++;
      } else {
        c.style.display = "none";
      }
    });

    const visible = cards.filter((c) => c.style.display === "");
    visible.sort((a, b) => {
      switch (sort) {
        case "title-asc":
          return a.dataset.title.localeCompare(b.dataset.title);
        case "title-desc":
          return b.dataset.title.localeCompare(a.dataset.title);
        case "price-asc":
          return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        case "price-desc":
          return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
        case "type-asc":
          return a.dataset.type.localeCompare(b.dataset.type);
        case "type-desc":
          return b.dataset.type.localeCompare(a.dataset.type);
        default:
          return 0;
      }
    });
    visible.forEach((c) => el("grid").appendChild(c));

    updateStats();
    showEmptyState(visibleCount);
  }

  function showEmptyState(count) {
    const grid = el("grid");
    if (count === 0 && cards.length > 0) {
      grid.innerHTML = `
        <div class="empty-state">
          <div class="empty-state-icon">🔍</div>
          <h3>No games found</h3>
          <p>Try adjusting your filters or search terms</p>
        </div>
      `;
    }
  }

  function updateStats() {
    const statsDisplay = el("stats-display");
    if (statsDisplay) {
      const visible = cards.filter((c) => c.style.display !== "none").length;
      statsDisplay.textContent = `Showing ${visible} of ${cards.length} games`;
    }
  }

  // Card interactions
  cards.forEach((c) => {
    const btn = c.querySelector(".add-btn"),
      panel = c.querySelector(".extras-panel"),
      list = panel.querySelector(".extras-list"),
      confirm = panel.querySelector(".confirm-btn"),
      cancel = panel.querySelector(".cancel-btn"),
      extras = JSON.parse(c.dataset.extras);

    list.innerHTML = extras
      .map(
        (e) => `
      <li><label>
        <input type="checkbox" data-extra="${e.name}" data-price="${e.price}">
        ${e.name} — €${e.price}
      </label></li>
    `
      )
      .join("");

    panel.classList.remove("open");

    if (btn) {
      btn.onclick = () => {
        const title = c.querySelector("h2 a").textContent,
          price = c.dataset.price,
          condition = c.dataset.condition;

        if (extras.length) {
          pending = { title, price, condition, link: c.dataset.link };
          panel.classList.add("open");
        } else {
          if (cart.has(title)) {
            cart.delete(title);
            showToast("Removed from cart", "info");
          } else {
            cart.set(title, { title, price, condition, link: c.dataset.link });
            showToast("Added to cart!", "success");
          }
          updateCart();
        }
      };
    }

    confirm.onclick = () => {
      if (!pending) return;
      cart.set(pending.title, pending);
      panel.querySelectorAll('input[type=\"checkbox\"]').forEach((ch) => {
        if (!ch.checked) return;
        const key = `${pending.title} – ${ch.dataset.extra}`;
        cart.set(key, {
          title: key,
          price: ch.dataset.price,
          condition: "",
          link: null,
        });
      });
      panel.classList.remove("open");
      pending = null;
      updateCart();
      showToast("Added to cart with extras!", "success");
    };

    cancel.onclick = () => {
      panel.classList.remove("open");
      pending = null;
    };
  });

  // Cart actions
  clearBtn.onclick = () => {
    if (confirm("Clear all items from cart?")) {
      cart.clear();
      updateCart();
      showToast("Cart cleared", "info");
    }
  };

  copyBtn.onclick = async () => {
    let txt = "";
    cart.forEach((i) => {
      const condText = i.condition ? ` [${i.condition}]` : "";
      txt += `${i.title}${condText}\\n`;
    });
    try {
      await navigator.clipboard.writeText(txt);
      copyBtn.textContent = "Copied!";
      showToast("Cart copied to clipboard!", "success");
      setTimeout(() => (copyBtn.textContent = "Copy to Clipboard"), 2000);
    } catch (e) {
      showToast("Failed to copy", "error");
    }
  };

  // Drawer controls
  function closeAll() {
    dr.classList.remove("open");
    filterDrawer.classList.remove("open");
    shield.style.display = "none";
  }

  function showShield() {
    shield.style.display = "block";
  }

  function openCart() {
    filterDrawer.classList.remove("open");
    dr.classList.add("open");
    showShield();
  }

  function openFilter() {
    dr.classList.remove("open");
    filterDrawer.classList.add("open");
    showShield();
  }

  ct.addEventListener("click", () => {
    if (dr.classList.contains("open")) {
      closeAll();
    } else {
      openCart();
    }
  });

  cb.addEventListener("click", closeAll);

  const filterBtns = [
    ...document.querySelectorAll('[data-action=\"open-filter\"]'),
  ];
  if (filterToggle) filterBtns.push(filterToggle);

  filterBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (filterDrawer.classList.contains("open")) {
        closeAll();
      } else {
        openFilter();
      }
    });
  });

  fcClose.addEventListener("click", closeAll);
  shield.addEventListener("click", closeAll);

  // Wishlist toggle
  if (wishlistToggle) {
    wishlistToggle.addEventListener("click", () => {
      showToast("Wishlist feature - Coming soon!", "info");
    });
  }

  // Filter clear
  fcClear.onclick = () => {
    si.value = "";
    fs.value = "All";
    ts.value = "All";
    ps.value = "All";
    pl.value = "All";
    cs.value = "All";
    sortSel.value = "title-asc";
    document.querySelector(
      'input[name=\"filter-extras\"][value=\"any\"]'
    ).checked = true;
    filterAndSort();
    showToast("Filters cleared", "info");
  };

  // Filter listeners
  [si, fs, ts, ps, pl, cs].forEach((elm) => (elm.oninput = filterAndSort));
  document
    .querySelectorAll('input[name=\"filter-extras\"]')
    .forEach((r) => (r.onchange = filterAndSort));
  sortSel.onchange = filterAndSort;

  updateCart();
  updateWishlistUI();
  filterAndSort();
}

/* ═══════════════════════════════════════════════════════════════════════
   QUICK VIEW MODAL
   ═══════════════════════════════════════════════════════════════════════ */

function setupQuickView() {
  const modal = el("quick-view-modal");
  if (!modal) return;

  const modalImg = modal.querySelector("img");
  const modalTitle = modal.querySelector("h3");
  const modalClose = modal.querySelector(".modal-close");

  // Add click listeners to all card images
  document.addEventListener("click", (e) => {
    const cardImage = e.target.closest(".card-image");
    if (cardImage) {
      const imageUrl = cardImage.dataset.image;
      const title = cardImage.dataset.title;

      if (imageUrl && imageUrl !== "undefined") {
        modalImg.src = imageUrl;
        modalTitle.textContent = title;
        modal.classList.add("active");
      }
    }
  });

  // Close modal
  modalClose.addEventListener("click", () => {
    modal.classList.remove("active");
  });

  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      modal.classList.remove("active");
    }
  });

  // ESC key to close
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("active")) {
      modal.classList.remove("active");
    }
  });
}

/* ═══════════════════════════════════════════════════════════════════════
   UTILITY FUNCTIONS
   ═══════════════════════════════════════════════════════════════════════ */

function el(id) {
  return document.getElementById(id);
}
